import * as THREE from "three";
import { DbBlockInstance } from "./DbBlockInstance";
import { DbLine } from "./DbLine";
import { DbMesh } from "./DbMesh";

/**
 * 块记录，块作为数据存储在model内，通过instance实例化到场景内
 */
export class DbBlockRecord{
    private  m_lineGeos:{[key:string]:DbLine[]} = {}
    private  m_meshGeos:{[key:string]:DbMesh[]} = {}
    instances:DbBlockInstance[] = [];
    Name: string|undefined;
    Id: string|undefined;
    public  get meshs(){
        return this.m_meshGeos;
    }
    public  get lines(){
        return this.m_lineGeos;
    }

    public set meshs(value:{[key:string]:DbMesh[]}){
        this.m_meshGeos = value;
    }
    public set lines(value:{[key:string]:DbLine[]}){
        this.m_lineGeos = value;
    }
}